export default {
  category: "Category",
  addCategory: "AddCategory",
  editCategory: "EditCategory",
};
